import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // 状态
  state: {
    isHome: true,
  },
  // state的计算属性
  getters: {
  },
  // 更改state的状态
  mutations: {
    homeTab(state, status) {
      state.isHome = status
    }
  },
  // 提交mutations,异步操作
  actions: {
  },
  // 模块化
  modules: {
  }
})
